import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { supabase } from '../lib/supabase';



export function Footer() {
  const [cities, setCities] = useState<any[]>([]);
  const [services, setServices] = useState<any[]>([]);
  const [articles, setArticles] = useState<any[]>([]);
  
  useEffect(() => {
    async function loadData() {
      // Load cities
      const { data: citiesData } = await supabase
        .from('cities')
        .select(`
          id,
          name,
          slug,
          state:state_id(code)
        `)
        .order('name')
        .limit(6);

      if (citiesData) {
        setCities(citiesData);
      }

      // Load services
      const { data: servicesData } = await supabase
        .from('services')
        .select('id, title, slug')
        .order('title');

      if (servicesData) {
        setServices(servicesData);
      }

      // Load articles
      const { data: articlesData } = await supabase
        .from('articles')
        .select('id, title, slug')
        .eq('published', true)
        .order('published_at', { ascending: false })
        .limit(3);

      if (articlesData) {
        setArticles(articlesData);
      }
    }

    loadData();
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Plumbers.Guru</h3>
            <div className="space-y-3">
              <p className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <a href="tel:(855) 513-0871" className="hover:text-blue-400">(855) 513-0871</a>
              </p>
              <p className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <a href="mailto:info@plumbers.guru" className="hover:text-blue-400">info@plumbers.guru</a>
              </p>
              <p className="flex items-center">
                <MapPin className="w-5 h-5 mr-2" />
                Nationwide Service
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              {services.map(service => (
                <li key={service.slug}>
                  <Link to={`/services/${service.slug}`} className="hover:text-blue-400">
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popular Locations */}
         <div>
            <h3 className="text-xl font-bold mb-4">Popular Locations</h3>
            <ul className="space-y-2">
              {cities.map(city => (
                <li key={city.id}>
                  <Link 
                    to={`/${city.slug}/${city.state.code.toLowerCase()}`}
                    className="hover:text-blue-400"
                  >
                    {city.name}, {city.state.code}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/locations" className="text-blue-400 hover:text-blue-300">
                  View All Locations →
                </Link>
              </li>
            </ul>
          </div>


          {/* Connect */}
          <div>
            <h3 className="text-xl font-bold mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="hover:text-blue-400">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="#" className="hover:text-blue-400">
                <Twitter className="w-6 h-6" />
              </a>
              <a href="#" className="hover:text-blue-400">
                <Instagram className="w-6 h-6" />
              </a>
              <a href="#" className="hover:text-blue-400">
                <Linkedin className="w-6 h-6" />
              </a>
            </div>
            <div className="space-y-2">
              <Link to="/about" className="block hover:text-blue-400">About Us</Link>
              <Link to="/careers" className="block hover:text-blue-400">Careers</Link>
              <Link to="/contact" className="block hover:text-blue-400">Contact</Link>
            </div>
          </div>
        </div>

        {/* Articles Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">Latest Articles</h3>
              <ul className="space-y-2">
                {articles.map(article => (
                  <li key={article.slug}>
                    <Link to={`/blog/${article.slug}`} className="block hover:text-blue-400">
                      {article.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="text-center space-y-4">
            <div className="flex justify-center space-x-4">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white">Terms of Service</Link>
              <Link to="/sitemap" className="text-sm text-gray-400 hover:text-white">Sitemap</Link>
            </div>
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Plumbers.Guru. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}